import type { SelectedOptionsProps } from '../../generic/Filter';
import { CheckboxFilterGroup, FilterPanel } from '../../generic/Filter';
import type { LicensingIssueType } from '../../../../shared/issuesV2';

const FILTER_OPTIONS: Array<{ key: LicensingIssueType, label: string }> = [
  { key: 'policy_conflict', label: 'Denied' },
  { key: 'policy_flag', label: 'Flagged' },
  { key: 'unlicensed_dependency', label: 'Unlicensed' },
];

const IssueTypeFilter = ({ selectedOptions, onSelect }: SelectedOptionsProps) =>
  <FilterPanel>
    <CheckboxFilterGroup
      title="Issue Type"
      options={FILTER_OPTIONS}
      selectedOptions={selectedOptions}
      onSelect={onSelect}
      testId="issues-issue-type-filters"
    />
  </FilterPanel>;

export default IssueTypeFilter;
